import React from 'react';
import styles from './liked-item.module.scss';
import { VoteProfileDto } from '@/api/profiles';
import { Like, PayedLike, UnpayedLike } from '@/types/profile';
import { UnpayLikedItem } from '../unpay-liked-item';
import { PayLikedItem } from '../pay-liked-item';

interface Props {
    img?: string | null;
    like: Like;
    onVoteProfile?: (vote: VoteProfileDto['value']) => void;
    isPaid: boolean;
}

export const LikedItem: React.FC<Props> = ({ like, onVoteProfile, isPaid }) => {
    return (
        <div className={styles.wrapper}>
            {isPaid ? (
                <PayLikedItem
                    like={like as PayedLike}
                    onVoteProfile={onVoteProfile} />
            ) : (
                <UnpayLikedItem like={like as UnpayedLike} />
            )}
        </div>
    );
};
